import * as React from 'react';
import { Button } from '@mui/material';
import PatternBrowserContainer from '@af-common/PatternDesignService/PatternBrowser/_containers/PatternBrowserContainer';
import Library from "@af-common/Resource/Library";
import SimplePicker from '../../../Misc/_components/SimplePicker';
import { ColorResult } from 'react-color';
import * as Immutable from 'immutable';
import { Trans } from 'react-i18next';
import AwareComponent from '@af-common/Common/_components/AwareComponent';
import ModuleDuplicateContainer from '../../_containers/ModuleDuplicateContainer';

export type Props = {
	moduleId?: string
	source?: string
	categoryId?: string
	colors?: Immutable.List<string>
	color_replacements?: Immutable.List<string>
	onSourceChange?: (source: string, category:string) => void,
	onThumbnailChange?: Function
	getColors?: Function
	removeModule?: Function
	onColorsChange?: Function
	onColorReplacementsChange?: Function
}

type State = {
	opened: boolean
	ratio: number
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class ModulePatternDesignServiceSettings extends AwareComponent<Props, State> {
	state = {
		opened: false,
		ratio: 0,
	} as State

	componentDidMount() {
		if(!this.props.source) this.open();
	}

	componentDidUpdate(_prevProps:Props) {
		if(this.propChanged(_prevProps, 'source')) {
			this.close();
		}
	}

	private open = () => {
		this.setState({opened: true})
	}

	private close = () => {
		if(!this.props.source) {
			this.props.removeModule();
		} else {
			this.setState({opened: false})
		}
	}

	private handleSourceChange = (id:string, categoryId:string) => {
		let PatternImages = Library.PatternDesignServiceLibrary;
		
		let source:any = PatternImages.get(id);
		if(!source) return;

		let sourceValue = PatternImages.get(id).value;

		this.setState({ratio: sourceValue.content.width / sourceValue.content.height});

		this.props.onSourceChange(id, categoryId);

		this.props.onThumbnailChange(sourceValue.content.src);
		this.props.onColorsChange(Immutable.List<string>());
		this.props.getColors(id, this.props.onColorsChange.bind(this));
	}

	private onColorChange = (key:number, color:ColorResult) => {
		let newColors = this.props.color_replacements.toArray();
		newColors[key] = color.hex;
		this.props.onColorReplacementsChange(Immutable.List<string>(newColors));
	}

	render = () => <>
		<PatternBrowserContainer selectedPattern={this.props.source} selectedPatternCategory={this.props.categoryId} opened={this.state.opened} title={<T>Pattern Library</T>} onOpen={this.open} onClose={this.close} onSelect={(id:string, categoryId:string) => this.handleSourceChange(id, categoryId)} element={
			<Button variant="outlined"><T>Switch Design</T></Button>
		}/>
		{ this.props.color_replacements && this.props.color_replacements.valueSeq().slice(0, 6).map((color:string, key:number) => {
			return <SimplePicker key={key} onColorChange={(color:ColorResult) => { this.onColorChange(key, color) }} label={<T>Color {{number: (key + 1)}}</T>} color={color}/>
		})}
		<div className="actions-wrapper">
			<ModuleDuplicateContainer moduleId={this.props.moduleId}/>
		</div>
	</>
}